// extracted by mini-css-extract-plugin
export var buttonContainer = "_84-1";
export var fontSizeSelect = "_84-3";
export var formatSelect = "_84-2";
export var formats = "_84-4";
export var hidden = "_84-5";
export var icon = "_84-6";
export var select = "_84-0";